import { renderBuildSortLabelExprSortDirectionTemplate } from '@next-adapter/templates/renderers/generators/sortable-header/build-sort-label-expr.js'
export function buildSortLabelExpr(): string {
  return renderBuildSortLabelExprSortDirectionTemplate()
}
